/**
 * Git Fit entry point.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/colors-and-type.css";
import "./styles/app.css";
import { App } from "./App";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
